import { defineComponent } from 'vue';
import { settings, cog } from 'ionicons/icons';
import { IonItem, IonIcon, IonLabel } from '@ionic/vue';
export default defineComponent({
    name: "SettingsButton",
    setup() {
        return { settings, cog };
    },
    components: {
        IonItem,
        IonIcon,
        IonLabel
    }
});
